import { Skeleton } from "antd";

const SkeletonNode = ({ width = '100%', rows = 2 }: { width?: string, rows?: number }) => (
  <Skeleton active={true} paragraph={{ rows: rows, width: width }}  title={{ width: '100px' }} />
);

export default SkeletonNode;